import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabase';
import Loading from '../../components/Loading';

const Home = () => {
    const [user, setUser] = useState(null);
    const [funnels, setFunnels] = useState(0);
    const [leads, setLeads] = useState(0);
    const [clicks, setClicks] = useState(0);

    useEffect(() => {
        const fetchUser = async () => {
            const { data, error } = await supabase.auth.getUser();
            setUser(data.user);
        }
        fetchUser();
        
    }, []);

    if (!user) return <Loading />;

    const stats = [
        {
            title: 'Funis',
            value: funnels,
            icon: '📊',
            color: 'from-blue-500 to-blue-600',
            bgColor: 'bg-gradient-to-r from-blue-500 to-blue-600'
        },
        {
            title: 'Leads',
            value: leads,
            icon: '👥',
            color: 'from-green-500 to-green-600',
            bgColor: 'bg-gradient-to-r from-green-500 to-green-600'
        },
        {
            title: 'Cliques',
            value: clicks,
            icon: '🎯',
            color: 'from-purple-500 to-purple-600',
            bgColor: 'bg-gradient-to-r from-purple-500 to-purple-600'
        }
    ];



    return (
        <div className='min-h-screen  '>
            <div className='max-w-7xl mx-auto'>
                {/* Header */}
                <div className='mb-8'>
                    <h1 className='text-4xl font-bold text-gray-800 mb-2'>
                        Olá, {user.email?.split('@')[0]}! 👋
                    </h1>
                    <p className='text-xl text-gray-600'>
                        Bem-vindo ao seu painel da Hotify
                    </p>
                </div>

                {/* Stats Grid */}
                <div className='grid grid-cols-1 md:grid-cols-3 gap-6 mb-8'>
                    {stats.map((stat, index) => (
                        <div key={index} className='bg-white rounded-xl shadow p-6 flex items-center gap-4'>
                             
                            <div>
                                <div className='text-gray-700 text-lg font-semibold'>{stat.title}</div>
                                <div className='text-2xl font-bold'>{stat.value.toLocaleString()}</div>
                            </div>
                        </div>
                    ))}
                </div>

                
 
            </div>
        </div>
    );
};

export default Home;